import axios from 'axios';

// Same-origin API on production (fee.oxfordkhajuri.online/backend/api).
// Override with REACT_APP_API_BASE for local/dev if needed.
export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (typeof window !== 'undefined'
    ? `${window.location.origin}/backend/api`
    : 'https://fee.oxfordkhajuri.online/backend/api');

const CSRF_KEY = 'csrfToken';

export function setCsrfToken(token) {
  if (token) {
    sessionStorage.setItem(CSRF_KEY, token);
  }
}

export function getCsrfToken() {
  return sessionStorage.getItem(CSRF_KEY) || '';
}

export function clearAuthStorage() {
  sessionStorage.removeItem(CSRF_KEY);
}

function toApiUrl(pathOrUrl) {
  if (!pathOrUrl) return API_BASE;
  if (/^https?:\/\//i.test(pathOrUrl)) {
    return pathOrUrl.replace(/^http:\/\//i, 'https://');
  }
  return `${API_BASE}/${String(pathOrUrl).replace(/^\//, '')}`;
}

axios.defaults.baseURL = API_BASE;
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const method = (config.method || 'get').toLowerCase();
  if (!['get', 'head', 'options'].includes(method)) {
    config.headers = config.headers || {};
    config.headers['X-CSRF-Token'] = getCsrfToken();
  }
  if (typeof config.url === 'string') {
    config.url = config.url.replace(/^http:\/\//i, 'https://');
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    if (response?.data?.csrfToken) {
      setCsrfToken(response.data.csrfToken);
    }
    return response;
  },
  (error) => Promise.reject(error)
);

/**
 * Credentialed fetch against the API (HTTPS + CSRF on mutating methods).
 */
export async function apiFetch(pathOrUrl, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const headers = { ...(options.headers || {}) };

  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    headers['X-CSRF-Token'] = getCsrfToken();
    if (options.body && !headers['Content-Type'] && !headers['content-type']) {
      headers['Content-Type'] = 'application/json';
    }
  }

  return fetch(toApiUrl(pathOrUrl), {
    ...options,
    method,
    headers,
    credentials: 'include',
  });
}

export default axios;
